import React, { useState, useEffect, useRef } from "react";
import { Card, Button, Form, Tabs, Tab, Accordion, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { setActiveTab, setUserTemplate } from '../../redux/actions/userAction'
import { ErrorMessage, Field, useField, Formik, Form as FForm } from 'formik';
import * as Yup from 'yup';
import TextError from '../../component/ErrorText';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import _ from "underscore";

const animatedComponents = makeAnimated();

const disabledArray = ['Gender', 'UIC', 'Client type', 'First name', 'Phone number (permanent)', 'QR code', 'Others', 'Age', 'Surname']

const RegistrationStep = () => {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const storeState = useSelector((state) => state)
  const userTemplate = useSelector((state) => state.programDetails.userTemplate)
  const userInputs = useSelector((state) => state.programDetails.details)
  const [tabKey, setKey] = useState(userInputs && userInputs.languages ? userInputs.languages[0].value : null)
  const [attribuetArray, setAttribuetArray] = useState(userTemplate.trackedentityattributes > 0 ? userTemplate.trackedentityattributes : [])
  const [questionObject, setQuestionObject] = useState({})
  const [optionsArray, setOptionsArray] = useState([])
  const [optionValuesLocaleObject, setOptionValuesLocaleObject] = useState({})
  const [optionValuesLocaleArray, setOptionValuesLocaleArray] = useState([])
  const [languagesArray, setLanguagesArray] = useState([])
  const [isEditQuestion, setIsEditQuestion] = useState(false)
  const [dataVariableToggle, setDataVariableToggle] = useState(false)
  const [attributeRenderKey, setAttributeRenderKey] = useState(0)

  const [dependentArray, setDependentArray] = useState([])

  const questionObjectSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    mandatory: Yup.string(),
    attributeRefType: Yup.string().required('Attribute Type is required'),
    parentQuestion: Yup.string(),
    dependentValue: Yup.string(),
  });

  // Variable for Mobile Render
  const [renderMobileViewToggle, setRenderMobileViewToggle] = useState(false)
  // Variable for Delete flow
  const [deleteVariableToggle, setDeleteVariableToggle] = useState(false)
  const [deletedAttributeArray, setDeletedAttributeArray] = useState(userTemplate.deletedObjects.deletedAttribute)
  const [currentAttributeList, setCurrentAttributeList] = useState([])
  const onElementSelect = selectedOption => {
    setCurrentAttributeList(selectedOption)
  }
  const pushQuestionListToAttribute = () => {
    let arrayHolder = attribuetArray
    arrayHolder.push(...currentAttributeList)
    let deleteArrHolder = deletedAttributeArray
    setDeletedAttributeArray(
      deleteArrHolder.filter(function (obj) {
        return !this.has(obj.trackedEntityAttributeId);
      }, new Set(currentAttributeList.map(obj => obj.trackedEntityAttributeId)))
    )
    setAttribuetArray(arrayHolder);
    setAttributeRenderKey(Math.random())
    setDeleteVariableToggle(false)
    console.log(currentAttributeList, deletedAttributeArray)
  }
  useEffect(() => {
    let tempHolder = userTemplate.trackedentityattributes
    tempHolder.map((el, id) => {
      if (!el['sortOrder'])
        el['sortOrder'] = id + 1

    })
    setAttribuetArray(tempHolder)
    setDependentArray(userTemplate.attributedependentquestions)
  })

  const pushQuestion = (values) => {
    console.log(values, optionValuesLocaleArray)
    setDataVariableToggle(false)
    let arrayHolder = attribuetArray
    let localeHolder = [...optionValuesLocaleArray]
    Object.keys(localeHolder).map(lang => {
      console.log(localeHolder, localeHolder[lang])
      // localeHolder[lang].map((local,idx) => {
      //     if(local.value == '')
      //     localeHolder[lang].splice(idx, 1)
      // })
    })
    if (values.attributeRefType == 'optionset') {
      values['optionvalues'] = optionsArray
      values['optionname'] = "option_" + Date.now();
    }
    else if (values.attributeRefType == 'checkbox')
      values['checkboxoption'] = optionsArray
    values['languages'] = languagesArray
    values.languages.map((lang, idx) => {
      if (lang.locale == 'en' || lang.value == '')
        values.languages.splice(idx, 1)
      // if(lang.value == '')
      //     values.languages.splice(idx, 1)
    })
    console.log(values.languages)
    if (isEditQuestion) {
      arrayHolder.map((el, idx) => {
        if (el.orignalname == values.orignalname) {
          el.name = values.name
          el.mandatory = values.mandatory
          el.languages = values.languages
          if (values.parentQuestion)
            el['parentQuestion'] = values.parentQuestion
          if (values.dependentValue)
            el['dependentValue'] = values.dependentValue
          if (el.attributeRefType == 'optionset') {
            el['optionvalues'] = optionsArray
            el['optionvaluesLocale'] = localeHolder
          }
        }
      })
    } else {
      values['orignalname'] = values.name
      values['optionvaluesLocale'] = localeHolder
      arrayHolder.push(values)
    }
    // Code For Dependency Logic
    console.log(dependentArray, values, "cehck me")
    let tempDepentHolder = dependentArray
    // check exisiting dependecy
    tempDepentHolder.map(element => {
      if (values.name && _.find(element.dependentdataelementnames, ['childdataelementname', values.name])) {
        if (element.dataelementname != values.parentQuestion) {
          let index = _.findIndex(element.dependentdataelementnames, { 'childdataelementname': values.name })
          element.dependentdataelementnames.splice(index, 1)
        }
      }
    })
    // END
    if (_.findIndex(tempDepentHolder, { 'dataelementname': values.parentQuestion }) != -1 
    && _.findIndex(tempDepentHolder, { 'matchingvalue': values.dependentValue } != -1
    )
    ) {
      tempDepentHolder.map(el => {
        if (el.dataelementname == values.parentQuestion) {
          if (_.find(el.dependentdataelementnames, ['childdataelementname', values.name])) {

          } else {
            el.dependentdataelementnames.push({ "childdataelementname": values.name })
          }
        }
      })
    } else if (values.parentQuestion) {
      let temp = {}
      temp['dataelementname'] = values.parentQuestion
      temp['matchingvalue'] = values.dependentValue
      temp['dependentdataelementnames'] = [{ "childdataelementname": values.name }]
      tempDepentHolder.push(temp)
      setDependentArray(tempDepentHolder)
    }
    console.log(tempDepentHolder, "tempDepentHolder")
    setAttribuetArray(arrayHolder)
    setAttributeRenderKey(Math.random())
  }
  const moveQuestion = (from, to, questionname) => {
    console.log(from, to)
    let tempArr = _.clone(attribuetArray)
    if (to != -1 && from < tempArr.length) {
      tempArr[from]['sortOrder'] = to + 1
      tempArr[to]['sortOrder'] = from + 1
      tempArr = _.sortBy(tempArr, ['sortOrder'])
    }
    userTemplate.trackedentityattributes = tempArr
    dispatch(setUserTemplate(userTemplate))
  }
  const renderAttributes = () => {
    return (
      <>
        <Card className="regcard">
          <Card.Header className="regcardheader d-flex justify-content-between">
            <span>Registration</span>
            <span className="">
              {storeState.user.isEdit ? <i
                onClick={() => {
                  setDeleteVariableToggle(true)
                  setRenderMobileViewToggle(false)
                  setDataVariableToggle(false)
                }} title="Add From Deleted List" className="fa-solid fa-list mr-2"></i> : null}
              <span onClick={() => {
                setQuestionObject({ mandatory: false, searchable: false, displayInList: false, name: '', attributeRefType: '' })
                setOptionsArray([])
                let tempArr = []
                userInputs.languages.map(el => {
                  tempArr.push({
                    locale: el.value,
                    property: "NAME",
                    value: ""
                  })
                })
                setLanguagesArray(tempArr)
                setOptionValuesLocaleArray([])
                setKey(userInputs && userInputs.languages ? userInputs.languages[0].value : null)
                setDataVariableToggle(true)
                setRenderMobileViewToggle(false)
                setDeleteVariableToggle(false)
                setIsEditQuestion(false)
              }} title="Add Question" className="addsign"><i aria-hidden="true" className="fa fa-plus"></i></span>
            </span>
          </Card.Header>
          <Card.Body className="regcardbody">

            <div className="table-responsive">
              <table className="table ss table-hover" id="programserviceTBL">
                <thead >
                  <tr >
                    <th width="30%">Questions</th>
                    <th >Type</th>
                    <th >Mandatory</th>
                    <th >Display</th>
                    <th >Searchable</th>
                    <th className="text-right">Actions</th>
                    <th className="text-right">Sequence</th>
                  </tr>
                </thead>
                <tbody className="formsbody"  >
                  {
                    _.sortBy(attribuetArray, 'sortOrder').map((element, idx) => {
                      if (element.name != 'registered by' && element.name != 'AddressLocation') {
                        return (<tr className={element.name == 'Gender' ? 'disabled' : ''} key={`elm2` + idx + attributeRenderKey}>
                          <td >{element.name}</td>
                          <td className="">{element.attributeRefType}</td>
                          <td className="">{element.mandatory == true ? "Yes" : "No"}</td>
                          <td className="td-actions">
                            <input onClick={(e) => {
                              let temp = attribuetArray
                              temp[idx].displayInList = Boolean(e.target.checked)
                              setAttribuetArray([...temp])
                            }} className="big-checkbox" checked={element.displayInList == true ? true : false} type='checkbox'></input>
                          </td>
                          <td className="td-actions"><input
                            onClick={(e) => {
                              let temp = attribuetArray
                              temp[idx].searchable = Boolean(e.target.checked)
                              setAttribuetArray([...temp])
                            }}
                            className="big-checkbox" checked={element.searchable == true ? true : false} type='checkbox'></input></td>
                          <td className="td-actions justify-content-center">
                            <button
                              onClick={() => {
                                console.log(element)
                                let tempArr = []
                                let langList = []
                                userInputs.languages.map(el => {
                                  tempArr.push({
                                    locale: el.value,
                                    property: "NAME",
                                    value: ""
                                  })
                                })
                                if (!Array.isArray(element.languages))
                                  element.languages = []
                                if (element.languages.length == 0) {
                                  setLanguagesArray(tempArr)
                                } else {
                                  tempArr.map(el => {
                                    element.languages.map(lang => {
                                      if (el.locale == lang.locale) {
                                        el.value = lang.value
                                      }
                                    })
                                  })
                                  setLanguagesArray(tempArr)
                                }
                                if (element.attributeRefType == 'optionset') {
                                  let temp = []
                                  // userInputs.languages.map((lang, id) => {
                                  if (Array.isArray(element.optionvaluesLocale)) {
                                    let localHolder = []
                                    element.optionvalues.map((option, idx) => {
                                      let tempObj = {}
                                      let temparr = []
                                      userInputs.languages.map(el => {
                                        if (_.findWhere(element.optionvaluesLocale[idx][option], { 'locale': el.value }))
                                          temparr.push(_.findWhere(element.optionvaluesLocale[idx][option], { 'locale': el.value }))
                                        else
                                          temparr.push({ "locale": el.value, "property": "NAME", "value": "" })
                                      })
                                      tempObj[option] = temparr
                                      localHolder.push(tempObj)
                                    })
                                    element.optionvaluesLocale = localHolder
                                    console.log(localHolder, "localHolder")
                                    setOptionValuesLocaleArray([])
                                    setOptionValuesLocaleArray(localHolder)
                                  } else {
                                    element.optionvalues.map(option => {
                                      if (Object.keys(element.optionvaluesLocale).length == 0 || element.optionvaluesLocale[option].length == 0) {
                                        let obj = {}
                                        obj[option] = userInputs.languages.map((lang) => {
                                          return {
                                            "locale": lang.value,
                                            "property": "NAME",
                                            "value": ""
                                          }
                                        })
                                        temp.push(obj)
                                      } else {
                                        let obj = {}
                                        let tempArr = userInputs.languages.map((lang) => {
                                          return {
                                            "locale": lang.value,
                                            "property": "NAME",
                                            "value": ""
                                          }
                                        })
                                        tempArr.map(elm => {
                                          var matched = element.optionvaluesLocale[option].filter(el => { if (elm.locale == el.locale) return el })
                                          if (matched.length > 0)
                                            elm.value = matched[0].value
                                        })
                                        obj[option] = tempArr
                                        temp.push(obj)
                                      }
                                      setOptionValuesLocaleArray([])
                                      setOptionValuesLocaleArray(temp)
                                    })
                                  }
                                  // })
                                }
                                element.attributeRefType == 'optionset' ? setOptionsArray(element.optionvalues) : (element.attributeRefType == 'checkbox' ? setOptionsArray(element.checkboxoption) : setOptionsArray([]))
                                setQuestionObject(element)
                                setKey(userInputs && userInputs.languages ? userInputs.languages[0].value : null)
                                setDataVariableToggle(true)
                                setIsEditQuestion(true)
                                console.log(questionObject)
                              }}
                              type="button" title="Edit Question" className="btn btn-info btn_Edit"><i className="fa fa-pencil-alt"></i></button>
                            <button
                              onClick={() => {
                                let tempDeleteHolder = deletedAttributeArray;
                                element["value"] = element.trackedEntityAttributeId
                                element["label"] = element.name
                                tempDeleteHolder.push(element)
                                setDeletedAttributeArray(tempDeleteHolder)
                                let temp = attribuetArray
                                temp.splice(idx, 1)
                                // setStageArray(stageArray)
                                setAttribuetArray([...temp])
                              }}
                              type="button" title="Delete Question" className={disabledArray.includes(element.name) ? 'disabled btn btn-danger btn_Edit' : ' btn btn-danger btn_Edit'}><i className="fas fa-trash"></i></button>
                          </td>
                          <td className="text-center sequence-column">
                            <span title="Move Up" onClick={() => moveQuestion(idx, idx - 1, element.name)}>
                              <i className="fas fa-long-arrow-alt-up"></i>
                            </span>
                            <span title="Move Down" onClick={() => moveQuestion(idx, idx + 1, element.name)}>
                              <i className="fas fa-long-arrow-alt-down"></i>
                            </span>
                          </td>
                        </tr>)
                      }
                    })}
                </tbody>
              </table>


            </div>

          </Card.Body>
        </Card>
      </>
    )
  }
  // console.log(attribuetArray,userTemplate)
  return (
    <>
      <div className="row pt-1">
        <div className="col-12 bnBtn">
          <button tabIndex="-1" type="button" className="btn wizard-btnb  ml-3" onClick={() => dispatch(setActiveTab('step1'))} >Back</button>

          <div>
            <button tabIndex="-1" type="button" className="btn wizard-btnb  mr-2"
              onClick={() => {
                setDataVariableToggle(false)
                setDeleteVariableToggle(false)
                setRenderMobileViewToggle((prev) => !prev)
              }} > {renderMobileViewToggle ? 'Hide' : 'Show'}  Preview</button>

            <button tabIndex="-1" type="button" className="btn wizard-btnn  mr-3" onClick={() => {
              let tempHolder = userTemplate
              tempHolder['attributedependentquestions'] = dependentArray
              tempHolder['deletedObjects'].deletedAttribute = deletedAttributeArray
              console.log(deletedAttributeArray)
              dispatch(setUserTemplate(userTemplate))
              dispatch(setActiveTab('step3'))
            }} >Next
            </button>
          </div>
        </div>
      </div>
      <div className="row m-2">
        <div className="col-8">
          {renderAttributes()}
          {/* <div className="form-group is-empty" id="eligible"><label className="col-form-label"><span>Eligible for TPT(Age in Years)</span></label><div className="form-inline"><input type="number" className="form-control if w-25" /> -<input type="number" className="form-control if w-25" /></div></div> */}
        </div>
        {dataVariableToggle ?
          <div className="col-4">
            <Formik
              innerRef={formRef}
              initialValues={questionObject}
              enableReinitialize
              validationSchema={questionObjectSchema}
              onSubmit={values => {
                pushQuestion(values)
              }}
            >
              {({ errors, touched }) => (
                <FForm className="">
                  <Card>
                    <Card.Header className="regcardheader">Data Variables
                      <span className="closesign" onClick={() => setDataVariableToggle(false)}><i aria-hidden="true" className="fa fa-times"></i></span>
                    </Card.Header>
                    <Card.Body className="regtabbody">
                      <Tabs
                        activeKey={tabKey == null ? userInputs.languages[0].value : tabKey}
                        onSelect={(k) => setKey(k)}
                        style={{ marginTop: '10px' }}
                      >
                        {userInputs.languages.map((language, idx) => {
                          return <Tab key={`elm4` + idx} eventKey={language.value} title={language.label} style={{ marginTop: '15px', padding: '10px' }}>
                            <Form.Group controlId="formBasicEmail">
                              {idx == 0 ?
                                <>
                                  <Field name='name'>
                                    {({ field, meta }) => {
                                      return (
                                        <>
                                          <Form.Label className="label">* Name</Form.Label>
                                          <input
                                            type='text'
                                            className='form-control'
                                            placeholder="Name"
                                            {...field}
                                          />
                                        </>
                                      )
                                    }}
                                  </Field>
                                  <ErrorMessage
                                    component={TextError}
                                    name="name"
                                  />
                                </> :
                                <>
                                  <Form.Label className="label">* Name</Form.Label>
                                  <input
                                    onChange={(e) => {
                                      let langArr = languagesArray
                                      langArr.map(lang => {
                                        if (lang.locale == language.value) {
                                          lang.value = e.target.value
                                        }
                                      })
                                      setLanguagesArray([...languagesArray])
                                    }}
                                    value={languagesArray[idx].value}
                                    type='text'
                                    className='form-control'
                                    placeholder="Name"
                                  />
                                </>}
                            </Form.Group>
                            {idx == 0 ?
                              <>
                                <Form.Group>
                                  <Field name='attributeRefType'>
                                    {({ field, meta }) => {
                                      return (
                                        <>
                                          <Form.Label className="label">* Select Type</Form.Label>
                                          <select
                                            type='text'
                                            className='form-control'
                                            {...field}
                                            disabled={isEditQuestion}
                                          >
                                            <option value="">Select Type</option>
                                            <option value="text">Text</option>
                                            <option value="optionset">Option List</option>
                                            <option value="number">Number</option>
                                            <option value="date">Date</option>
                                            {/* <option value="checkbox">Checkbox Options</option> */}
                                          </select>

                                        </>
                                      )
                                    }}
                                  </Field>
                                  <ErrorMessage
                                    component={TextError}
                                    name="attributeRefType"
                                  />
                                </Form.Group>
                              </> : null}
                            {/* {((formRef.current.values.attributeRefType == 'optionset' || formRef.current.values.attributeRefType == 'checkbox') && idx != 0) ?
                                                            <p>Option List</p>
                                                            : null} */}
                            {
                              (formRef.current != null && (formRef.current.values.attributeRefType == 'optionset' || formRef.current.values.attributeRefType == 'checkbox')) ?
                                <>
                                  <p>Option list</p>
                                  {optionsArray.map((el, id) => {
                                    if (idx == 0) {
                                      return (
                                        <InputGroup key={`elm_5` + id} className="mb-3">
                                          <FormControl
                                            key={`elm5` + id}
                                            onChange={(e) => {
                                              let tempObj = {
                                                "name": e.target.value,
                                                "code": language.value,
                                                "transalationid": ""
                                              }
                                              console.log(questionObject, id)
                                              if (storeState.user.isEdit && isEditQuestion) {
                                                let tempObj = { ...questionObject }
                                                if (tempObj['options'][id]) {
                                                  if (tempObj['options'][id]['id']) {
                                                    tempObj['options'][id]['code'] = e.target.value
                                                    tempObj['options'][id]['name'] = e.target.value
                                                    tempObj['options'][id]['isupdate'] = true
                                                    tempObj['isupdate'] = true
                                                  } else {
                                                    tempObj['options'][id]['name'] = e.target.value
                                                  }
                                                } else {
                                                  let optObj = {
                                                    'name': e.target.value,
                                                    'sortOrder': id
                                                  }
                                                  tempObj['options'].push(optObj)
                                                }
                                                setQuestionObject(tempObj)
                                              }
                                              let arryHolder = optionsArray
                                              arryHolder[id] = e.target.value
                                              setOptionsArray([...arryHolder])


                                              // NEW logic
                                              let aH = optionValuesLocaleArray
                                              let temp = {}
                                              temp[e.target.value] = []
                                              temp[e.target.value] = Object.values(aH[id])[0]
                                              aH[id] = temp
                                              setOptionValuesLocaleArray([...aH])
                                            }}
                                            value={el}
                                            type='text'
                                            className='form-control'
                                          />
                                          <Button
                                            variant="outline-secondary"
                                            onClick={(e) => {
                                              let tempObj = { ...questionObject }
                                              tempObj['options'][id]['isdelete'] = true
                                              tempObj['options'][id]['isupdate'] = true
                                              tempObj['isupdate'] = true
                                              setQuestionObject(tempObj)
                                              optionsArray.splice(id, 1)
                                              setOptionsArray([...optionsArray])
                                              optionValuesLocaleArray.splice(id, 1)
                                              setOptionValuesLocaleArray([...optionValuesLocaleArray])
                                            }}
                                          >
                                            <i className="fa fa-trash-alt"></i>
                                          </Button>
                                        </InputGroup>
                                      )
                                    } else {
                                      return (
                                        <>
                                          <InputGroup key={`elm_6` + id} className="mb-3">
                                            <FormControl
                                              key={`elm6` + id}
                                              onChange={(e) => {
                                                if (isEditQuestion && questionObject.id) {
                                                  let tempObj = { ...questionObject }
                                                  tempObj['options'][id]['isupdate'] = true
                                                  setQuestionObject(tempObj)
                                                }
                                                // NEw logic
                                                let aH = optionValuesLocaleArray
                                                aH[id][optionsArray[id]][idx].value = e.target.value
                                                setOptionValuesLocaleArray([...aH])
                                              }}
                                              value={optionValuesLocaleArray[id] ? (optionValuesLocaleArray[id][optionsArray[id]][idx] ? optionValuesLocaleArray[id][optionsArray[id]][idx].value : null) : null}
                                              // value={optionValuesLocaleObject[language.value] ? (optionValuesLocaleObject[language.value][id] ? optionValuesLocaleObject[language.value][id].name : null) : null}
                                              type='text'
                                              className='form-control'
                                            />
                                          </InputGroup>
                                        </>
                                      )
                                    }
                                  })}
                                  {idx == 0 ?
                                    <Button key={`elm__6` + idx} onClick={() => {
                                      setOptionsArray([...optionsArray, ''])
                                      var temp = []
                                      temp = userInputs.languages.map((lang) => {
                                        return {
                                          "locale": lang.value,
                                          "property": "NAME",
                                          "value": ""
                                        }
                                      })
                                      setOptionValuesLocaleArray([...optionValuesLocaleArray, { '': temp }])

                                    }} className="addbtn btn-sm">Add Options</Button> : null
                                  }
                                </>
                                : null
                            }
                          </Tab>
                        })}

                      </Tabs>
                      <br />
                      <Form.Group>
                        <Field name="mandatory">
                          {({ field, meta }) => {
                            return (
                              <>
                                <Form.Label className="label">* Mandatory</Form.Label>
                                <div className="radio-item">
                                  <input
                                    {...field}
                                    value={true}
                                    checked={field.value == true}
                                    name="mandatory"
                                    type="radio"
                                    onClick={(e) => {
                                      setQuestionObject({ ...questionObject, mandatory: Boolean(e.target.value) })
                                    }}
                                  />
                                  <label htmlFor="true">Yes</label>
                                </div>

                                <div className="radio-item">
                                  <input
                                    {...field}
                                    value={false}
                                    name="mandatory"
                                    checked={field.value == false}
                                    type="radio"
                                    onClick={(e) => {
                                      setQuestionObject({ ...questionObject, mandatory: Boolean(e.target.value) })
                                    }}
                                  />
                                  <label htmlFor="false">No</label>
                                </div>
                              </>
                            )
                          }}
                        </Field>
                        <ErrorMessage
                          component={TextError}
                          name="mandatory"
                        />
                      </Form.Group>
                      <Form.Group>
                        <Field name='parentQuestion'>
                          {({ field, meta }) => {
                            return (
                              <>
                                <Form.Label className="label">Parent question</Form.Label>
                                <Form.Control as="select" {...field}>
                                  <option value="">-</option>
                                  {attribuetArray.map((element, idx) => {
                                    if (element.attributeRefType == "optionset") {
                                      return <option key={idx} value={element.name} >{element.name}</option>
                                    }
                                  })}
                                </Form.Control>
                              </>
                            )
                          }}
                        </Field>
                      </Form.Group>
                      {(formRef.current != null && formRef.current.values.parentQuestion != ''
                        && attribuetArray[_.findIndex(attribuetArray, { 'name': formRef.current.values.parentQuestion })]
                        // && attribuetArray[formRef.current.values.parentQuestion]
                      ) ?
                        <Form.Group>
                          <Field name='dependentValue'>
                            {({ field, meta }) => {
                              return (
                                <>
                                  <Form.Label>Dependent Value</Form.Label>
                                  <Form.Control as="select" {...field}>
                                    <option>-</option>
                                    {/* {_.findIndex(attribuetArray,['name',formRef.current.values.parentQuestion])} */}
                                    {attribuetArray[_.findIndex(attribuetArray, { 'name': formRef.current.values.parentQuestion })].optionvalues.map((element, idx) => {
                                      return <option key={element} >{element}</option>
                                    })}
                                  </Form.Control>
                                </>
                              )
                            }}
                          </Field>
                        </Form.Group>
                        : null
                      }
                      <div>
                        <Button type="submit" className="addbtn"> {isEditQuestion ? 'Update' : 'Add'}</Button>
                      </div>
                    </Card.Body>
                  </Card>
                </FForm>
              )}
            </Formik>
          </div>
          : null}
        {
          deleteVariableToggle ?
            <div className="col-4">
              <Card>
                <Card.Header className="regcardheader">Deleted Variables List
                  <span className="closesign" onClick={() => setDeleteVariableToggle(false)}><i aria-hidden="true" className="fa fa-times"></i></span>
                </Card.Header>
                <Card.Body className="regtabbody">
                  <Select
                    className="basic-multi-select multiselect"
                    classNamePrefix="select"
                    isMulti
                    options={deletedAttributeArray}
                    menuIsOpen={true}
                    components={animatedComponents}
                    onChange={onElementSelect}
                  />
                  <div className="d-flex justify-content-between mt-3">
                    <Button onClick={pushQuestionListToAttribute} className="addbtn mt-3"> Add</Button>
                    <Button onClick={() => setDeleteVariableToggle(false)} className="addbtn mt-3" >Close</Button>
                  </div>
                </Card.Body>
              </Card>
            </div>
            : null
        }
        {
          renderMobileViewToggle ? <>
            <div className="smartphone">
              <div className="header">
                Registration
              </div>
              <Formik
                // initialValues={}
                enableReinitialize
                onSubmit={values => {
                }}
              >
                <FForm className="">
                  {_.sortBy(attribuetArray, 'sortOrder').map((element, idx) => {
                    if (element.attributeRefType == 'text') {
                      return (
                        <>
                          <Form.Group className="pl-2 pr-2" controlId="formBasicEmail">
                            <Form.Label className="label">{element.mandatory ? "*" : ""}{element.name}</Form.Label>
                            <input
                              type='text'
                              className='form-control'
                              placeholder=""
                            />
                          </Form.Group>
                        </>
                      )
                    }
                    if (element.attributeRefType == 'number') {
                      return (
                        <>
                          <Form.Group className="pl-2 pr-2" controlId="formBasicEmail">
                            <Form.Label className="label">{element.mandatory ? "*" : ""}{element.name}</Form.Label>
                            <input
                              type='number'
                              className='form-control'
                              placeholder=""
                            />
                          </Form.Group>
                        </>
                      )
                    }
                    if (element.attributeRefType == 'date') {
                      return (
                        <>
                          <Form.Group className="pl-2 pr-2" controlId="formBasicEmail">
                            <Form.Label className="label">{element.name}</Form.Label>
                            <input
                              type='date'
                              className='form-control'
                              placeholder=""
                            />
                          </Form.Group>
                        </>
                      )
                    }
                    if (element.attributeRefType == 'optionset') {
                      return (
                        <>
                          <Form.Group className="pl-2 pr-2" controlId="formBasicEmail">
                            <Form.Label className="label">{element.name}</Form.Label>
                            <select
                              type='text'
                              className='form-control'
                            >
                              <option value="">Select Type</option>
                              {element.optionvalues.map(option => {
                                return <option value={option}>{option}</option>
                              })}
                            </select>
                          </Form.Group>
                        </>
                      )
                    }
                    if (element.attributeRefType == 'checkbox') {
                      return (
                        <>
                          <Form.Group className="pl-2 pr-2" controlId="formBasicEmail">
                            <span className="float-left">{element.name}</span>
                            {/* <Form.Label className="label mb-2">{element.name}</Form.Label> */}
                            <br></br>
                            <div>
                              {element.checkboxoption.map(option => {
                                return <>
                                  <div key={`default-checkbox`} className="mb-1">
                                    <Form.Check
                                      className="text-left"
                                      type="checkbox"
                                      id={`default-checkbox`}
                                      label={option}
                                    />
                                  </div>
                                </>
                              })}
                            </div>
                          </Form.Group>
                        </>
                      )
                    }
                  })
                  }
                </FForm>
              </Formik>
            </div>
          </> : null
        }
      </div>
      <div className="row pt-1 mb-4">
        <div className="col-12 bnBtn">
          <button tabIndex="-1" type="button" className="btn wizard-btnb  ml-3" onClick={() => dispatch(setActiveTab('step1'))}>Back</button>
          <button tabIndex="-1" type="button" className="btn wizard-btnn  mr-3" onClick={() => {
            let tempHolder = userTemplate
            tempHolder['attributedependentquestions'] = dependentArray
            tempHolder['deletedObjects'].deletedAttribute = deletedAttributeArray
            dispatch(setUserTemplate(userTemplate))
            dispatch(setActiveTab('step3'))
          }} >Next
          </button>
        </div>
      </div>
    </>
  )
}
export default RegistrationStep;